import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    height: '600px',
    gap: '12px',
    paddingTop: '100px',
  },
  icon: { marginBottom: '12px' },
};
